<template>
  <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left titleText--text font-weight-bold">User Name</th>
                    <th class="text-left titleText--text font-weight-bold">Have Acess</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(items) in listapps" :key="items.id">
                    <td class="text-left titleText--text font-weight-bold">{{ items.app_name }}</td>
                    <td class="text-left">
                      <v-checkbox
                        color="#2CD8C5"
                        v-model="items.ismap"
                        @change="OnMappingChange($event, items.id, items.mapid)"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
</template>

<script>
import apifactory from "../api";
export default {
  props: ['id', 'userName'],
  data() {
    return {
      dialog: false,
      username: "",
      listapps: [],
      userid: 0,
    };
  },
  mounted() {
    this.loaduserapps()
  },
  computed: {},
  methods: {
    OnMappingChange(event, varappid, varmappid) {
      //alert(varmappid);
      if (event) {
        if (varmappid != 0) {
          this.showAlertConfirmForReMapp(varappid, varmappid);
        } else {
          this.showAlertConfirmForMapp(varappid);
        }
      }
      if (!event) {
        this.showAlertConfirmForUnMapp(varappid, varmappid);
      }
    },
    showAlertConfirmForMapp(varappid) {
      this.$swal({
        title: "Are you sure?",
        text: "Are you want to mapp this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, mapp it!",
      }).then((result) => {
        if (result.value) {
          this.mappuserapps(varappid);
        }
      });
    },
    showAlertConfirmForUnMapp(varappid, varmappid) {
      this.$swal({
        title: "Are you sure?",
        text: "Are you want to unmapp this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, unmapp it!",
      }).then((result) => {
        if (result.value) {
          this.unmappuserapps(varappid, varmappid);
        }
      });
    },
     showAlertConfirmForReMapp(varappid, varmappid) {
      this.$swal({
        title: "Are you sure?",
        text: "Are you want to mapp this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, unmapp it!",
      }).then((result) => {
        if (result.value) {
          this.remappuserapps(varappid, varmappid);
        }
      });
    },
    mappuserapps(varappid) {
      apifactory
        .apicall_userapp_mapp(this.userid, varappid)
        .then((res) => {
          //JSON.stringify(res)
          // alert(res.data.message);
          this.$swal("User Mapp", res.data.message, "sucess");
          this.loaduserapps();
        })
        .catch(function (error) {
           this.$swal("User Mapp", error, "error");
        });
    },
    unmappuserapps(varappid, varmappid) {
      //alert(varmappid);
      apifactory
        .apicall_userapp_unmapp(varmappid)
        .then((res) => {
          alert(JSON.stringify(res));
          this.loaduserapps();
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    remappuserapps(varappid, varmappid) {
      //  alert(varmappid);
      apifactory
        .apicall_userapp_remapp(varmappid)
        .then((res) => {
         JSON.stringify(res)
          this.loaduserapps();
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    OnloadCall(varuserid, varusername) {
      //alert(varuserid);
      this.dialog = true;
      this.username = varusername;
      this.userid = varuserid;
      //  alert('ddd');

      this.loaduserapps();
    },
    closeForm() {
      this.dialog = false;
      this.$parent.reloadfromchild();
    },
    loaduserapps() {
      apifactory
        .apicall_userappaccess(this.userid)
        .then((res) => {
          // alert(JSON.stringify(res));
          if (res.status != 200) {
            this.listapps = null;
            // alert(this.processdataitems.length);
          } else {
            this.listapps = res.data.userwise_mapped_applist;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
  },
};
</script>

<style scoped>
.inactive-bg {
  color: red;
}

.inactive-bg-green {
  color: green;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row) {
  border-color: white !important;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  border-color: white !important;
  background-color: white !important;
}
</style>
